import { Children, ReactNode } from 'react';
import styles from './ArrowButton.module.css';

interface Props {
    children: ReactNode;
    onClick: () => void;
}

export const ArrowButton = ({ children, onClick }: Props) => {

    return (
        <button onClick={onClick} className={`${styles.button}`}>
            {children}
        </button>
    )
}